<template>
    <div class="tsa-loginForm">
        <div class="form-content">
            <h2>立即登录/注册，固定您的维权证据！</h2>
            <p class="tip">30秒注册，维权证据早固定早安心！</p>
            <div class="form-area">
                <div class="item">
                    <p class="name">手机号/邮箱</p>
                    <div class="value">
                        <input type="text" v-model="ruleForm.loginName" placeholder="请输入手机号/邮箱">
                    </div>
                </div>
                <div class="item">
                    <p class="name">验证码</p>
                    <div class="value">
                        <input type="text" v-model="ruleForm.password" placeholder="请输入验证码">
                        <div class="verifyCode">
                            <TsaVerifyCode ref="TsaVerifyCode" :phone="ruleForm.loginName" @on-start="getCodeSuccess"></TsaVerifyCode>
                        </div>
                    </div>
                </div>
                <div class="checked">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <p><label @click="checked=!checked">我已阅读并同意</label><span class="blue" @click="gotoAgreement(0)">《用户注册与使用协议》</span><span class="">和</span><span class="blue" @click="gotoAgreement(1)">《隐私保护协议》</span></p>
                </div>
                <div class="btn" @click="submit">
                    <p>登录/注册</p>
                </div>
            </div>
        </div>
        <!-- 注册协议 -->
        <TsaAgreementDialog v-model="regDialog" title="协议更新" @on-cancel="cancelDialog" @on-agree="agree('signup')">
            <RegDocUpdateTips @openRegistrationDialog='registrationDialog=true,regDialog=false' />
        </TsaAgreementDialog>
        <!-- 隐私协议 -->
        <TsaAgreementDialog v-model="privacyDialog" title="隐私保护协议" @on-cancel="nologin" @on-agree="agree('privacy')">
            <iframe class="agreementDoc" :src="privacyAgreement" frameborder="0"></iframe>
        </TsaAgreementDialog>
        <!-- 用户注册与使用协议 -->
        <TsaAgreementDialog v-model="registrationDialog" title="用户注册与使用协议" type='alert' @on-cancel="regDialog=true,registrationDialog=false">
            <iframe class="agreementDoc" :src="regAgreement" frameborder="0"></iframe>
        </TsaAgreementDialog>
    </div>
</template>

<script>
import TsaVerifyCode from '../verifyCode'
import { sendSmsCode, login, signProtocol, loginout } from '@/api/userCenter'
import { me } from '@/api/service'
import NoTrace from '@/utils/noTrace'
import { mobilePhoneReg, emailReg } from '@/config/regular.js'
import { mapState } from 'vuex'
import TsaAgreementDialog from './components/agreementDialog/index.vue'
import RegDocUpdateTips from './components/RegDocUpdateTips.vue';
import { GetRequest, isPCBrowser } from '@/common/utils'
import qs from 'qs'
export default {
    components: {
        TsaVerifyCode,
        TsaAgreementDialog,
        RegDocUpdateTips
    },
    data () {
        return {
            checked: false,
            regDialog:false,
            registrationDialog:false,
            privacyDialog:false,
            regAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/registration',
            privacyAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/privacy',
            ruleForm: {
                loginName: '',
                password: '',
            },
        }
    },
    computed: {
        ...mapState({
            visualDeviceType: (state) => state.app.visualDeviceType,
        }),
    },
    mounted () {
       
    },
    methods: {
        async gologin(){
            try {
                let result = await me();
                this.loginSuccessFinalRes(result)
            } catch (error) {
                console.log(error)
            }
            
        },
        cancelDialog(){
            this.regDialog=false;
            if(this.protocolUpdateStatus==1){
                this.privacyDialog=true;
            }else{
                this.gologin();
            }
        },
        agree(protocolType){
            let that=this;
            that.regDialog=false;
            that.privacyDialog=false;
            signProtocol({ protocolType:protocolType, access_token: this.access_token, }).then((res) => {
                if(res.protocolUpdateStatus==1){
                    that.privacyDialog=true;
                    return false;
                }
                that.gologin();
            })
        },
        nologin(){
            let that=this;
            loginout().then((res) => {
                that.privacyDialog=false;
            }).catch((err) => {
                console.log(err);
            });
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendSmsCode(params);
                    resolve(res)
                    that.$TsaToastV2.show({
                        message: '验证码发送成功',
                        type: 'success',
                    })
                }catch (error) {
                    reject(error)
                    that.$refs.TsaVerifyCode.reset();
                    // 阿里无痕验证失败
                    if (error.aliFali) {
                        that.$TsaToastV2.show({
                            message: '短信验证码发送失败',
                            type: 'error',
                        })
                    } else {
                        let { status, data ={} } = error
                        let { code, message } = data
                        if (status === 403) {
                            if (code === 1) {
                                that.$TsaConfirmV2.show({
                                    message: '该账号已注册，登录后即可使用可信时间戳产品，是否确定登录?',
                                    cancelButtonText: '暂不登录',
                                    confirmButtonText: '确认登录',
                                    onConfirm: () => {
                                        that.$TsaConfirmV2.hide()
                                        // 再次获取验证码 verifyLoginName传0 不在校验是否已经注册了
                                        let obj = { 
                                            signupType:params.signupType,
                                            verifyLoginName: 0,
                                        }
                                        that.getCodeSuccess(obj)
                                    }
                                })
                            } else {
                                that.$TsaToastV2.show({
                                    message: message || '短信验证码发送失败',
                                    type: 'error',
                                })
                            }
                        }
                    }
                }
            })
        },
        getCodeSuccess ({ signupType, verifyLoginName = 1 } = {}) {
            NoTrace.start((nvc) => {
                this.nvc = nvc
                this.$refs.TsaVerifyCode.getCode();
            }, this.executeFun, {
                signupType,
                loginName: this.ruleForm.loginName,
                afsVersion: 2,
                verifyLoginName,
            })
        },
        submit () {
            let signupType = ''
            if (mobilePhoneReg.test(this.ruleForm.loginName)) {
                signupType = 'PHONE'
                this.submitFun(signupType)
            } else if (emailReg.test(this.ruleForm.loginName)) {
                signupType = 'EMAIL'
                this.submitFun(signupType)
            } else {
                this.$TsaToastV2.show({
                    type: 'warn',
                    message: '请输入正确的手机号或者邮箱'
                })
            }
            
        },
        submitFun (signupType) {
            if (!this.ruleForm.password) {
                this.$TsaToastV2.show({
                    type: 'warn',
                    message: '请输入验证码'
                })
                return
            }
            if (!this.nvc) {
                return this.$TsaToastV2.show({
                    type: 'warn',
                    message: '请获取验证码'
                })
            }
            if (!this.checked) {
                this.$TsaConfirmV2.show({
                    message: '您是否阅读并同意<span style="color: #165DFF" id="registration">《用户注册与使用协议》</span>和<span style="color: #165DFF" id="privacy">《隐私保护协议》</span>？',
                    cancelButtonText: '拒绝',
                    confirmButtonText: '同意',
                    onOpen: () => {
                        this.domClcik()
                    },
                    onConfirm: () => {
                        this.$TsaConfirmV2.hide()
                        this.checked = true
                        this.submitFun()
                    }
                })
                return
            }
            this.$TsaLoadingV2.show()
            let loginName = this.ruleForm.loginName.trim()
            let password = this.ruleForm.password.trim()
            let inviteCode = GetRequest().code
            login({
                loginName,
                loginType: 'SMS',
                password,
                clientId: '995280',
                inviteCode: inviteCode,
                nvc: this.nvc,
            }).then((result) => {
                this.$TsaLoadingV2.hide()
                this.loginSuccessRes(result)
            }).catch((error) => {
                this.$TsaLoadingV2.hide()
                this.loginFailRes(error)
            });
        },
        // 协议跳转 登录  注册页面需要
        loginSuccessRes (result) {
            let { signupProtocolUpdateStatus, protocolUpdateStatus, subUserProtocolUpdateStatus, access_token, parentId } = result
            // 如果是子账号
            if (parentId != 0) {
                // 手动执行登出
                loginout()
                return this.$TsaToastV2.show({
                    message: '该账号为子账号，请使用主账号登录',
                    type: 'error',
                })
            }
            this.access_token = access_token
            // 注册协议更新 1.不需要弹出更新协议框 2. 需要弹出.    // 隐私协议更新需要授权
            // 注册协议更新 1.不需要弹出更新协议框 2. 需要弹出
            if (signupProtocolUpdateStatus === 2) {
                this.regDialog = true
                return
            }
            // 隐私协议更新需要授权
            if (protocolUpdateStatus === 1) {
                this.privacyDialog = true
                return
            }
            if (subUserProtocolUpdateStatus === 1) {
                // 不确定是 0 还是 '0'
                if (result.parentId == 0) {
                    this.loginSuccessFinalRes(result)
                } else {
                    // 执行登出
                    loginout()
                    this.$TsaAlertV2.show({
                        message: '请尽快通知主账号登录系统，并在“子账号管理”页面同意《子账号开通责任条款》，否则可能影响子账号功能的使用。',
                    });
                    
                }
                return
            }
            // 登录成功
            this.loginSuccessFinalRes(result)
        },
        loginSuccessFinalRes (result) {
            let obj = {
                code: GetRequest().code,
                redirectUrl: encodeURIComponent(window.location.href),
                sourcePlatform: 'ipr',
                firstLogin: result.isLogin ? 'false' : 'true',
            }
            // 如果是pc端浏览器 isPCBrowser()
            
            // window.name = JSON.stringify(obj)//给跳转后页面接收的参数
            // window.location.href = process.env.VUE_APP_BD +'/dist-m/resisterSuccess';
            
            window.location.href = process.env.VUE_APP_BD +'/dist-m/resisterSuccess' + '?' + qs.stringify(obj)
            // location.reload()
        },
        loginFailRes (error) {
            if (error) {
                let { status, data }  = error
                if (status === 403) {
                    if (data) {
                        let { code, message } = data
                        message = message.replace('。', '')
                        switch (code) {
                            case 600004:
                                // 动态验证码错误。
                                this.$TsaToastV2.show({
                                    message: '验证码输入错误',
                                    type: 'error',
                                })
                                break
                            case 600006:
                                // 账户未注册，请先注册.
                                this.$TsaToastV2.show({
                                    message: '账号未注册，请先注册',
                                    type: 'error',
                                })
                                break
                            case 600015:
                                // 密码错误
                                this.$TsaToastV2.show({
                                    message: '账号或密码有误，请重新输入',
                                    type: 'error',
                                })
                                break
                            case 600008:
                                // 该用户已经被禁用，请联系管理人员
                                this.$TsaToastV2.show({
                                    message,
                                    type: 'error',
                                })
                                break
                            case 600009:
                                // 该用户已经被删除，请联系管理人员.
                                this.$TsaToastV2.show({
                                    message,
                                    type: 'error',
                                })
                                break
                            case 600010:
                                // 账号冲突，请联系客服处理.
                                this.$TsaToastV2.show({
                                    message,
                                    type: 'error',
                                })
                                break
                            case 600011:
                                // 老用户
                                this.$TsaToastV2.show({
                                    type: 'error',
                                    message: '出于安全考虑，您的账户已被暂时冻结，请联系客服：400-0186-091。'
                                })
                            break
                            default:
                                this.$TsaToastV2.show({
                                    type: 'error',
                                    message
                                })
                        }
                    } else {
                        this.$TsaToastV2.show({
                            type: 'error',
                            message: '系统异常'
                        })
                    }
                }
            }
        },
        domClcik () {
            this.$nextTick(() => {
                document.querySelector('#registration').onclick = () => {
                    this.gotoAgreement(0)
                }
                document.querySelector('#privacy').onclick = () => {
                    this.gotoAgreement(1)
                }
            })
        },
        gotoAgreement (val) {
            let url, title
            switch (val) {
                case 0:
                    title = '用户注册与使用协议'
                    url = process.env.VUE_APP_USERCENTERUI + '/agreement/registration'
                break
                case 1:
                    title = '隐私保护协议'
                    url = process.env.VUE_APP_USERCENTERUI + '/agreement/privacy'
                break
            }
            this.$TsaConfirmV2.hide()
            this.$TsaAgreementPreviewDialog.show({
                title,
                url
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    .agreementDoc {
        width: 100%;
        height: 100%;
    }
    @media screen and (min-width:1101px) {
        @import './css/pc.scss';
    }
    @media screen and (max-width:1100px) {
        @import './css/mobile.scss';
    }
</style>